import React, { FC } from 'react';

export const IconAdd: FC<React.PropsWithChildren<{ className?: string }>> = ({ className }) => (
  // @ts-ignore slot attribute is required for market, but not part of the React svg type.
  <svg slot="icon" className={className} width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.1993 7.59968L0.999947 7.59968" stroke="currentColor" />
    <path d="M7.59956 1.00002L7.59956 14.1993" stroke="currentColor" />
  </svg>
);
